export default {

  namespaced: true,

  state: () => ({

    accountsPlanGroups: [],
    planGroup: [],
    accountPlanGroup: [],
    accountPlans: [],
    accountPlan: {},
  }),

  mutations: {
    setAccountPlans(state, accountPlans) {
      state.accountPlans = accountPlans
    },

    setAccountPlan(state, data) {
      state.accountPlan = data
    },

    setAccountsPlanGroups(state, data) {
      state.accountsPlanGroups = data
    },
    setAccountsPlanGroup(state, data) {
      state.planGroup = data
    }
  },

  actions: {
    async getAccountsPlans({ dispatch, commit }, params) {
      await axios.get("/erp/account/accountplan", { params: params })
        .then(response => {

          commit('setAccountPlans', response.data.accountPlans)

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        });
    },

    async getAccountPlansList({ dispatch, commit }, params) {

      const data = await axios.get("/erp/account/accountplan", { params });

      return data

    },

    async getAccountPlan({ dispatch, commit }, id) {

      await axios.get("/erp/account/accountplan/" + id)
        .then(response => {

          commit('setAccountPlan', response.data)

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        });
    },

    async getAccountsPlanGroups({ dispatch, commit }, params) {

      await axios.get("/erp/account/accountplangroup", { params: params })
        .then(response => {

          commit('setAccountsPlanGroups', response.data.accountPlanGroups)

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        });
    },

    async storeAccountPlanGroup({ dispatch, commit }, params) {

      await axios.get("/erp/account/accountplangroup", params)
        .then(response => {

          commit('setAccountPlansGroup', response.data)

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        });
    },

    async storeAccountPlan({ dispatch, commit }, params) {

      const data = await axios.post("/erp/account/accountplan", params);

      return data
    },

    async updateAccountPlan({ dispatch, commit }, { params, id }) {

      let url = '/erp/account/accountplan'

      if (id) {
        url = url + '/' + id
      }

      const data = await axios.put(url, params);

      return data
    },


    async getAccountPlanGroup({ dispatch, commit }, id) {

      await axios.get("/erp/account/accountplangroup/" + id)
        .then(response => {
          commit('setAccountsPlanGroup', response.data)

        }).catch(error => {

          commit("userHasLoadedWithError", { error: error }, { root: true });

        });
    },

    async storeAccountPlanGroup({ dispatch, commit }, { params, id }) {
      let url = '/erp/account/accountplangroup'

      if (id == '') {
        const data = await axios.post(url, params);
        return data
      }
      if (id != '') {
        url = url + '/' + id
        const data = await axios.put(url, params);
        return data
      }
    },

  }
}
